// extracted by mini-css-extract-plugin
export default {"root":"MintWidget_root__rlKO6","wide":"MintWidget_wide__WJDGd"};